const isLocalhost = window.location.hostname.includes("localhost") || 
                   window.location.hostname === "127.0.0.1";

export const clientId = "756fef97-cd12-411e-b60f-5a5fd4af2710"; // AppTesting Trask

export const msalConfig = {
  auth: {
    clientId,
    authority: "https://login.microsoftonline.com/common/",
    // Simple dynamic redirect URI - works with any domain
    redirectUri: isLocalhost ? "http://localhost:3000" : window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid","profile","User.Read", "Application.Read.All"],
};